/**
 * Zakres dat: szybkie wybory (30 dni / 90 dni / biezacy rok / caly czas)
 * + dwa pola daty od/do. Zaznaczony szybki wybor = pelne tlo + #fff INLINE
 * (wymog motywu, jak chipy filtrow).
 */
import React from 'react';
import { SZYBKIE_ZAKRESY, dzisISO } from './format';

const pole = { padding: '4px 6px', fontSize: '11px', border: '1px solid var(--border)', borderRadius: '4px', backgroundColor: 'var(--card-bg)', color: 'var(--text)' };

const ZakresDat = ({ zakres, onZmiana, zablokowane }) => {
  const dzis = dzisISO();
  const aktywny = SZYBKIE_ZAKRESY.find(z => z.od() === zakres.od && zakres.do === dzis)?.id || null;
  return (
    <div data-testid="zakres-dat" style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '6px', fontSize: '12px' }}>
      <span style={{ color: 'var(--text-secondary)', fontWeight: 600 }}>Zakres</span>
      <div role="group" aria-label="Szybki zakres" style={{ display: 'flex', gap: '6px' }}>
        {SZYBKIE_ZAKRESY.map(z => {
          const jest = z.id === aktywny;
          return (
            <button
              key={z.id}
              type="button"
              data-testid={`zakres-${z.id}`}
              aria-pressed={jest}
              disabled={zablokowane}
              onClick={() => onZmiana({ od: z.od(), do: dzis })}
              style={{
                padding: '4px 10px', fontSize: '11px', fontWeight: 600, borderRadius: '12px', cursor: 'pointer',
                border: '1px solid var(--primary)',
                background: jest ? 'var(--primary)' : 'var(--card-bg)',
                color: jest ? '#fff' : 'var(--primary)',
              }}
            >
              {z.etykieta}
            </button>
          );
        })}
      </div>
      <label style={{ fontSize: '11px', color: 'var(--text-secondary)' }}>
        od{' '}
        <input type="date" aria-label="Data od" value={zakres.od || ''} max={zakres.do || dzis} disabled={zablokowane}
          onChange={(e) => e.target.value && onZmiana({ ...zakres, od: e.target.value })} style={pole} />
      </label>
      <label style={{ fontSize: '11px', color: 'var(--text-secondary)' }}>
        do{' '}
        <input type="date" aria-label="Data do" value={zakres.do || ''} min={zakres.od || undefined} max={dzis} disabled={zablokowane}
          onChange={(e) => e.target.value && onZmiana({ ...zakres, do: e.target.value })} style={pole} />
      </label>
    </div>
  );
};

export default ZakresDat;
